export enum LabelTypesEnum {
  XLLabel = '0',
  SmallLabel = '1',
  XLVerticalLabel = '2',
  XSLabel = '3',
  SpreaderLabel = '4',
  GrinderLabel = '5',
  XLLabelBig = '6',
  XLVerticalLabelBig = '7',
  GlassVialLabel = '8',
  SmallRound = '9',
  XSNewLabel = '10',
  XSNewLabelWithEan = '11',
  XLLabelBigNew = '12',
}

export enum LabelTypesEnumTranslations {
  XLLabel = 'Große Dose',
  SmallLabel = 'Kleine Dose',
  XLVerticalLabel = 'Nachfüllpackung',
  XSLabel = 'XS Etikett',
  SpreaderLabel = 'Streuer-Etikett',
  GrinderLabel = 'Mühlen-Etikett',
  XLLabelBig = 'XL Dose',
  XLVerticalLabelBig = 'XL Nachfüllpackung',
  GlassVialLabel = 'Glasfläschchen',
  SmallRound = 'rund 45x45',
  XSNewLabel = 'XS Neues Etikett',
  XSNewLabelWithEan = 'XS Neues Etikett mit EAN',
  XLLabelBigNew = 'XL-dose NEU'
}
